import React from 'react'
import { useLocation } from 'react-router-dom'
import banner from '../assets/top.png'

const Topbar = () => {
  const location = useLocation()
  const isHome = location.pathname === '/'

  if (!isHome) {
    return null
  }

  return (
    <div
      className="w-full px-4 py-2.5 text-center bg-cover bg-center border-b border-black/20 sm:py-3"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(${banner})`,
      }}
    >
      <p className="text-sm text-white font-normal sm:text-base">
        Discover Your Dream Property with Millennium Realty
      </p>
    </div>
  )
}

export default Topbar
